module.exports = __webpack_public_path__ + "img/NanGang.dd121f73.png";